export const numberFormatter = (numberInput: number): string => {
  const format = new Intl.NumberFormat().format;

  return format(numberInput);
};
